import { FETCH_WORKLIST_START, FETCH_WORKLIST_ERROR, FETCH_WORKLIST_SUCCESS, SET_WORKLIST_PAGINATION, SET_WORKLIST_FILTER, SHOW_WORKLIST_MODAL, UPDATE_STUDY_ERROR, UPDATE_STUDY_SUCCESS, HIDE_WORKLIST_MODAL, UPDATE_STUDY_START, RESET_WORKLIST_FILTER } from "../../actions/groupadmin/worklistActions";
import { paginationSize, past29DaysDate, todaysDate } from '../../../constants/constants';
import _ from 'lodash';

const INIT_STATE = {
    worklist: [],
    loading: false,
    message: '',
    error: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    searchFilter: {
        searchText: "",
//        risId: 1,
        mipIds: [],
        modalityIds: [],
        myCasesOnly: true,
        startDate: null,
        endDate: null
    },
    sortConditions: [{ sortBy: "visitStart", dataType: "DATE", sortType: "desc" }],
    showModal: false,
    selectedVisit: null,
    selectedVisitLoading: false
}

export const worklistReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_WORKLIST_START:
            return { ...state, error: '', message: '', loading: true }

        case FETCH_WORKLIST_SUCCESS:
            return { ...state, error: '', message: '', loading: false, worklist: action.worklist.length > 0 ? [...action.worklist] : [] }

        case SET_WORKLIST_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }

        case FETCH_WORKLIST_ERROR: {
            return { ...state, loading: false, error: '' }
        }
        case SET_WORKLIST_FILTER: {
            let newState = { ...state };
            newState.searchFilter = { ...action.payload.searchFilter }
            newState.sortConditions = action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            return {
                ...newState
            }
        }
        case UPDATE_STUDY_START: {
            return { ...state, error: '', message: '', selectedVisitLoading: true }
        }
        case SHOW_WORKLIST_MODAL: {
            return { ...state, showModal: true, selectedVisit: action.selectedVisit };
        }
        case UPDATE_STUDY_ERROR:
        case HIDE_WORKLIST_MODAL: {
            return { ...state, error: '', message: '', selectedVisitLoading: false, showModal: false }
        }
        case UPDATE_STUDY_SUCCESS: {
            let newState = { ...state };
            let index = state.worklist.findIndex(worklistItem => worklistItem.reportId === action.visit.reportId)

            if (index > -1) {
                let modifiedVisit = newState.worklist[index];
                modifiedVisit.priority = action.visit.priority;
                newState.worklist[index] = { ...modifiedVisit };
            }

            return { ...newState, error: '', message: '', selectedVisitLoading: false, showModal: false, }
        }

        case RESET_WORKLIST_FILTER: {
            let newState = _.cloneDeep(state);
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }

        default:
            return state;
    }
}

export default worklistReducer;